export const iconFontAwesomeArrowsArrowUpWideShort = (
	<i className="fa-solid fa-arrow-up-wide-short"></i>
);
